import * as types from './mutations-type'
// import util from '@/util/methods'

const mutations = {
  [types.CHECK_MOBILE] (state, mobile) {
    state.isMobile = mobile
  },
  // 检测是否到底部
  [types.CHECK_BOTTOM] (state, toggle) {
    state.isBottom = toggle
  },
  [types.LOGIN] (state, login) {
    state.isLogin = login
  },
  [types.USER_INFO] (state, user) {
    state.userInfo = user
  },
  [types.SET_BASE_INFO] (state, info) {
    state.baseInfo = info
  },
  // 申请状态信息
  [types.APPLY_STATUS_INFO] (state, applyStatusInfo) {
    state.applyStatusInfo = applyStatusInfo
  },
  [types.SET_GLOBAL_LAYERS] (state, data) {
    state.globalLayers = data
  }
}

export default mutations
